<template>

    <section class="detail">

        <navigation selected="coords"></navigation>

        <div class="inner">

            <form onsubmit="return false;">
                <fieldset class="fields_shipping">
                    <div class="line"></div>

                    <div class="gift_cards_header">
                        <h1>{{ copydeck.page_coords.txt_delivery_method[ lang ] }}</h1>
                    </div>

                    <fieldset class="shipping_selection">
                        <div class="fieldset_head">
                            <span class="label" v-html="copydeck.cart.txt_description[ lang ]"></span>
                            <span class="shipping_price">{{ copydeck.cart.txt_price[ lang ] }}</span>
                        </div>


                        <div class="form_group" v-for="(theme, index) in giftCardThemes">
                            <div class="radio_wrapper">
                                <input type="radio"
                                       :id="'shipping-type-' + theme.id"
                                       name="shipping-type"
                                       :value="theme.id"
                                       v-model="delivery.method">
                                <label :for="'shipping-type-' + theme.id">{{ theme.label }}</label>
                                <button type="button"
                                        data-toggle="modal-preview-email-xmas"
                                        @click="showModal(theme.preview)">
                                    (<span>{{ copydeck.page_coords.txt_preview[ lang ] }}</span>)
                                </button>
                            </div>
                            <span class="shipping_price value-0">0</span>
                        </div>
                        <!-- div.form_group -->

                        <!-- Modal - Preview email  -->
                        <div v-if="isPreviewModalVisible"
                             id="modal-preview"
                             data-modal="modal"
                             class="modal modal-preview-email">
                            <div class="modal-content">
                                <button type="button"
                                        class="btn btn-close"
                                        data-dismiss="modal"
                                        @click="isPreviewModalVisible = false">
                                    <span class="screen-reader-text">Fermer</span>
                                </button>

                                <div class="modal-body">
                                    <img :src="previewModalImageSrc" alt="">
                                </div>
                            </div>
                        </div>

                        <div class="form_group">
                            <div class="radio_wrapper">
                                <input type="radio"
                                       id="shipping-type-mail"
                                       name="shipping-type"
                                       value="mail"
                                       v-model="delivery.method">
                                <label for="shipping-type-mail">{{ copydeck.page_coords.txt_mail[ lang ] }}</label>
                            </div>
                            <span class="shipping_price">{{productByMail.price}}$</span>
                        </div>
                        <!-- div.form_group -->



                        <ul class="nav-tabs" role="tablist" v-if="orderCount > 1">
                            <li>
                                <button type="button"
                                        id="one-tab"
                                        aria-controls="one"
                                        aria-selected="true"
                                        :class="oneEmailDeliveryRecipient ? 'active' : ''"
                                        @click="() => setDeliveryToMode(true)">
                                    {{ copydeck.page_coords.btn_one_recipient[ lang ] }}
                                </button>
                            </li>
                            <li>
                                <button type="button"
                                        id="many-tab"
                                        aria-controls="many"
                                        aria-selected="false"
                                        :class="!oneEmailDeliveryRecipient ? 'active' : ''"
                                        @click="() => setDeliveryToMode(false)">
                                    {{ copydeck.page_coords.btn_many_recipient[ lang ] }}
                                </button>
                            </li>
                        </ul>

                        <!--                        <div class="shipping_note">-->
                        <!--                            <p><i>{{ copydeck.page_coords.txt_activation_notice[lang] }}</i></p>-->
                        <!--                            <p><i><button type="button" role="button">{{ copydeck.page_coords.txt_click_here[lang] }}</button> {{ copydeck.page_coords.txt_if_you_offer_to_the_same_person[lang] }}</i></p>-->
                        <!--                        </div>-->
                    </fieldset>

                    <!-- ************************************************************* -->

                    <fieldset class="shipping_name_group" v-if="(oneEmailDeliveryRecipient || orderCount === 1)">

                        <legend>{{ copydeck.page_order.title_gift_card[ lang ] }}</legend>

                        <div class="form_group">
                            <label for="field-to">{{ copydeck.page_coords.txt_to[ lang ] }} :</label>
                            <input type="text"
                                   name="field-to"
                                   id="field-to"
                                   maxlength="100"
                                   :value="getDeliveryByProductId(-1, -1, 'to' )"
                                   @change="setDeliveryInfo(-1, -1, 'to', false, $event)"/>
                            <span>({{ copydeck.page_coords.txt_optional[ lang ] }})</span>
                        </div>


                        <div class="form_group">
                            <label for="field-from">{{ copydeck.page_coords.txt_from[ lang ] }} :</label>
                            <input type="text"
                                   name="field-from"
                                   id="field-from"
                                   maxlength="100"
                                   :value="getDeliveryByProductId(-1,-1, 'from')"
                                   @change="setDeliveryInfo(-1, -1,'from', false, $event)"/>
                            <span>({{ copydeck.page_coords.txt_optional[ lang ] }})</span>
                        </div>

                        <div class="form_group label-top">
                            <label for="text_message">{{ copydeck.page_coords.txt_message[ lang ] }} :</label>
                            <textarea name="text_message" id="text_message" cols="30" rows="5" maxlength="256"
                                      :value="getDeliveryByProductId(-1,-1, 'message')"
                                      @change="setDeliveryInfo(-1, -1,'message', false, $event)"
                            ></textarea>
                            <span>({{ copydeck.page_coords.txt_optional[ lang ] }})</span>
                        </div>
                    </fieldset>

                    <fieldset class="shipping_name_group"
                              v-for="(order, orderIndex) in sortedOrdersWithoutByMail"
                              v-else-if="!oneEmailDeliveryRecipient"
                              :key="`product-${order.id}`">


                        <div v-for="i in getOrderQuantity(order)">

                            <legend>{{ getProductName(order) }} #{{ i }}</legend>

                            <div class="form_group">
                                <label>{{ copydeck.page_coords.txt_to[ lang ] }} :</label>
                                <input type="text"
                                       :value="getDeliveryByProductId(order.id_product, order.customGiftCard ? orderIndex  : i - 1, 'to', order.customGiftCard)"
                                       @change="setDeliveryInfo(order.id_product, order.customGiftCard ? orderIndex  : i - 1,'to', order.customGiftCard, $event)"/>
                                <span>({{ copydeck.page_coords.txt_optional[ lang ] }})</span>
                            </div>


                            <div class="form_group">
                                <label>{{ copydeck.page_coords.txt_from[ lang ] }} :</label>
                                <input type="text"
                                       :value="getDeliveryByProductId(order.id_product, order.customGiftCard ? orderIndex  : i - 1, 'from', order.customGiftCard)"
                                       @change="setDeliveryInfo(order.id_product, order.customGiftCard ? orderIndex  : i - 1,'from', order.customGiftCard, $event)"/>
                                <span>({{ copydeck.page_coords.txt_optional[ lang ] }})</span>
                            </div>

                        </div>
                    </fieldset>


                </fieldset>


                <!-- ************************************************************* -->

                <div class="cart_resume">
                    <subtotal :orders="sortedOrders"></subtotal>
                </div>

                <div class="cart_modify">
                    <router-link :to="getRoute('recap')" class="cta previous" id="cta_restart">
                        <span>{{ copydeck.page_gift_card.btn_edit_coords[ lang ] }}</span>
                    </router-link>

                    <p>{{ copydeck.page_coords.txt_cannot_used_gift_card_for_reservations[ lang ] }}</p>
                </div>

                <payment ref="refPayment" :errors="errors">

                    <ul class="nav-tabs" role="tablist" v-if="!deliveryIsEmail">
                        <li>
                            <button type="button"
                                    id="one-tab"
                                    aria-controls="one"
                                    aria-selected="true"
                                    :class="shipToInvoiceAddress ? 'active' : ''"
                                    @click="() => setShipToMode(true)">
                                {{ copydeck.page_coords.btn_ship_to_same[ lang ] }}
                            </button>
                        </li>
                        <li>
                            <button type="button"
                                    id="many-tab"
                                    aria-controls="many"
                                    aria-selected="false"
                                    :class="!shipToInvoiceAddress ? 'active' : ''"
                                    @click="() => setShipToMode(false)">
                                {{ copydeck.page_coords.btn_ship_to_other[ lang ] }}
                            </button>
                        </li>
                    </ul>

                    <input type="hidden"
                           id="need_shipping_address"
                           name="need_shipping_address"
                           v-model="delivery.need_shipping_address"/>

                    <fieldset class="fields_payment fields-step-4" v-if="deliveryIsMail && !shipToInvoiceAddress">
                        <legend class="bar">{{ copydeck.component_payment.txt_shipping_coords[ lang ] }}</legend>

                        <div class="form_group">
                            <label for="shipping-firstname"
                                   :class="checkErrorClass('shipping-firstname')">{{
                                    copydeck.component_payment.txt_coords_firstname[ lang ]
                                }} :</label>
                            <input type="text"
                                   id="shipping-firstname"
                                   name="shipping-firstname"
                                   v-model="shipping.firstname"
                                   required="">
                            <div class="status-error"
                                 :aria-hidden="!hasError('shipping-firstname')"
                                 v-show="hasError('shipping-firstname')"> {{ getErrorMessage( 'shipping-firstname' ) }}
                            </div>
                        </div>
                        <!-- div.form_group -->

                        <div class="form_group">
                            <label for="shipping-lastname"
                                   :class="checkErrorClass('shipping-lastname')">{{
                                    copydeck.component_payment.txt_coords_lastname[ lang ]
                                }} :</label>
                            <input type="text"
                                   id="shipping-lastname"
                                   name="shipping-lastname"
                                   v-model="shipping.lastname"
                                   required="">
                            <div class="status-error"
                                 :aria-hidden="!hasError('shipping-firstname')"
                                 v-show="hasError('shipping-firstname')"> {{ getErrorMessage( 'shipping-lastname' ) }}
                            </div>
                        </div>
                        <!-- div.form_group -->

                        <div class="form_group">
                            <label for="shipping-address1"
                                   :class="checkErrorClass('shipping-address1')">{{
                                    copydeck.component_payment.txt_shipping_address1[ lang ]
                                }} :</label>
                            <input type="text"
                                   data-type="shipping_info"
                                   id="shipping-address1"
                                   name="shipping-address1"
                                   v-model="shipping.address1"
                                   required="">
                            <div class="status-error"
                                 :aria-hidden="!hasError('shipping-address1')"
                                 v-show="hasError('shipping-address1')"> {{ getErrorMessage( 'shipping-address1' ) }}
                            </div>
                        </div>
                        <!-- div.form_group -->

                        <div class="form_group">
                            <label for="shipping-address2"
                                   :class="checkErrorClass('shipping-address2')">{{
                                    copydeck.component_payment.txt_coords_address2[ lang ]
                                }} :</label>
                            <input type="text"
                                   data-type="invoice_info"
                                   data-link="#hidden_invoice_cc_address2"
                                   id="shipping-address2"
                                   name="shipping-address2"
                                   v-model="shipping.address2">
                            <div class="status-error"
                                 :aria-hidden="!hasError('shipping-address2')"
                                 v-show="hasError('shipping-address2')"> {{ getErrorMessage( 'shipping-address2' ) }}
                            </div>
                        </div>
                        <!-- div.form_group -->

                        <div class="form_group">
                            <label for="shipping-city"
                                   :class="checkErrorClass('shipping-city')">{{
                                    copydeck.component_payment.txt_coords_city[ lang ]
                                }} :</label>
                            <input type="text"
                                   data-type="invoice_info"
                                   data-link="#hidden_invoice_cc_city"
                                   id="shipping-city"
                                   name="shipping-city"
                                   v-model="shipping.city"
                                   required="">
                            <div class="status-error"
                                 :aria-hidden="!hasError('shipping-city')"
                                 v-show="hasError('shipping-city')"> {{ getErrorMessage( 'shipping-city' ) }}
                            </div>
                        </div>
                        <!-- div.form_group -->

                        <div class="form_group">
                            <label for="shipping-postal-code"
                                   :class="checkErrorClass('shipping-postal-code')">{{
                                    copydeck.component_payment.txt_coords_postal_code[ lang ]
                                }} :</label>
                            <input type="text"
                                   data-type="invoice_info"
                                   data-link="#hidden_invoice_cc_postal_code"
                                   id="shipping-postal-code"
                                   name="shipping-postal-code"
                                   v-model="shipping.postal_code"
                                   required="">
                            <div class="status-error"
                                 :aria-hidden="!hasError('shipping-postal-code')"
                                 v-show="hasError('shipping-postal-code')"> {{
                                    getErrorMessage( 'shipping-postal-code' )
                                }}
                            </div>
                        </div>
                        <!-- div.form_group -->

                        <div class="form_group">
                            <label for="hidden_invoice_cc_province"
                                   :class="checkErrorClass('hidden_invoice_cc_province')">{{
                                    copydeck.component_payment.txt_coords_province[ lang ]
                                }} :</label>

                            <select data-type="invoice_info"
                                    data-link="#hidden_invoice_cc_province"
                                    id="shipping-province"
                                    name="shipping-province"
                                    required=""
                                    v-model="shipping.province">
                                <option value="QC">Québec</option>
                                <option value="AB">Alberta</option>
                                <option value="BC">Colombie-Britannique</option>
                                <option value="PE">Île-du-Prince-Édouard</option>
                                <option value="MB">Manitoba</option>
                                <option value="NB">Nouveau-Brunswick</option>
                                <option value="NS">Nouvelle-Écosse</option>
                                <option value="NU">Nunavut</option>
                                <option value="ON">Ontario</option>
                                <option value="SK">Saskatchewan</option>
                                <option value="NL">Terre-Neuve et Labrador</option>
                                <option value="NT">Territoires du Nord-Ouest</option>
                                <option value="YT">Yukon</option>

                            </select>
                            <div class="status-error"
                                 :aria-hidden="!hasError('shipping-province')"
                                 v-show="hasError('shipping-province')"> {{ getErrorMessage( 'shipping-province' ) }}
                            </div>
                        </div>
                        <!-- div.form_group -->

                        <div class="form_group">
                            <label for="hidden_invoice_cc_country"
                                   :class="checkErrorClass('hidden_invoice_cc_country')">{{
                                    copydeck.component_payment.txt_coords_country[ lang ]
                                }} :</label>
                            <!--                                <input type="text" data-type="invoice_info" data-link="#hidden_invoice_cc_country" id="shipping-country" name="shipping-country" value="-->
                            <!--" required />-->
                            <select data-type="invoice_info"
                                    data-link="#hidden_invoice_cc_country"
                                    id="shipping-country"
                                    name="shipping-country"
                                    required=""
                                    v-model="shipping.country">
                                <option value="CA">Canada</option>
                            </select>
                            <div class="status-error"
                                 :aria-hidden="!hasError('shipping-country')"
                                 v-show="hasError('shipping-country')"> {{ getErrorMessage( 'shipping-country' ) }}
                            </div>
                        </div>
                        <!-- div.form_group -->


                    </fieldset>


                    <input type="hidden"
                           id="need_different_email_address"
                           name="need_different_email_address"
                           v-model="delivery.need_different_email_address"/>

                    <ul class="nav-tabs" role="tablist" v-if="deliveryIsEmail">
                        <li>
                            <button type="button"
                                    id="one-tab"
                                    aria-controls="one"
                                    aria-selected="true"
                                    :class="emailToInvoiceEmail ? 'active' : ''"
                                    @click="() => setEmailToMode(true)">
                                {{ copydeck.page_coords.btn_email_to_same[ lang ] }}
                            </button>
                        </li>
                        <li>
                            <button type="button"
                                    id="many-tab"
                                    aria-controls="many"
                                    aria-selected="false"
                                    :class="!emailToInvoiceEmail ? 'active' : ''"
                                    @click="() => setEmailToMode(false)">
                                {{ copydeck.page_coords.btn_email_to_other[ lang ] }}
                            </button>
                        </li>
                    </ul>

                    <div class="form_group" v-if="deliveryIsEmail && !emailToInvoiceEmail">
                        <label for="sending-email"
                               :class="checkErrorClass('sending-email')">{{
                                copydeck.component_payment.sending_email[ lang ]
                            }}&nbsp;:</label>
                        <input type="text"
                               data-type="invoice_info"
                               data-link="#hidden_invoice_sending_email"
                               id="sending-email"
                               name="sending-email"
                               placeholder="exemple@exemple.ca"
                               required=""
                               v-model="invoice.sending_email">
                        <div class="status-error"
                             :aria-hidden="!hasError('sending-email')"
                             v-show="hasError('sending-email')"> {{ getErrorMessage( 'sending-email' ) }}
                        </div>
                    </div>
                    <!-- div.form_group -->

                </payment>


                <button type="button"
                        role="button"
                        class="newsletter_btn"
                        @click="showNewsletter">
                    <span>{{ copydeck.page_gift_card.btn_subscribe_to_newsletter[ lang ] }}</span>
                </button>

                <waitable-button @click="onStartPaymentProcess"
                                 :waiting="isProcessingPayment"
                                 :label="copydeck.page_gift_card.btn_confirm[lang]"></waitable-button>

                <div class="processing" v-show="showModalProcessing">
                    <div class="wrapper">
                        <svg xmlns="http://www.w3.org/2000/svg" width="320" height="320" viewBox="0 0 320 320">
                            <path class="a"
                                  d="M125.18,55.81c7.86-19.77,4.55-32,1.71-35.69-1-1.33-1.9-1.52-2.44-1.45-9.4,1.13-19.88,6.92-20.32,7.18l-2.31,1.28,2.61.5c17.38,3.19,18.86,21.89,18.88,27.55ZM10.29,201.32l.87,2c.26.56,6.39,14.3,19.91,19.13,8,2.83,16.77,1.82,26.18-2.74a36.21,36.21,0,0,1,.62,6.82c0,4.35-.82,9.74-4,14.1-4.14,5.63-11.33,8.33-21.43,8.06l-2.49-.06,1.82,1.72c.24.26,25.92,24.13,50.64,8.76,4.26,5.23,6.56,10.26,6.56,15a15.61,15.61,0,0,1-.19,2.43c-.9,5.57-5,10.64-12.26,15.06l-1.45.87,1.5.79c.34.16,32.86,16.85,52.45-13.3,2.7.89,21,8,27.52,35.65l1.86,0c.09-.34,7.87-35.6,29-38.23,3.46,8.35,8.86,14.22,16.26,17.31,15.94,6.68,35-1.47,35.82-1.81l1.9-.82-1.88-.91c-11.79-5.76-18.39-12-19.61-18.65a13.75,13.75,0,0,1-.19-2.29c0-6.06,4.35-10.9,6.8-13.52,5.57,6.18,12.18,9.56,19.69,9.88,17.7.8,34-15,34.69-15.64l2.54-2.51-3.43.86c-8.26,2.1-14.77.82-19.41-3.78-6.8-6.8-7.93-19.16-7.93-25.12,0-.93,0-1.69.06-2.25,9.25,4.62,17.93,5.78,25.85,3.11,13.61-4.56,20-18.13,20.24-18.73l.91-2-2.08.7c-11.14,3.67-20,3.41-26.22-.78-7.59-5.12-9.28-14.29-9.67-18.18,30.31,2.83,46.23-29.76,46.39-30.1l1.56-3.32-3,2.13c-.24.2-24.78,17.2-46.49,3.19-15.14-9.79-28.3-32.8-30-52.46-.66-7.57.18-18,7.71-25,3.93-3.66,9.08-4.75,15.28-3.3,13.85,3.22,28.26,17.88,32.54,29,5.2,13.5,2.19,25.36-3.26,29.64-3.71,2.91-8.57,2.56-13.7-1-6.31-4.34-9.88-10.61-9.87-17.19,0-4.36,1.72-8.11,4.57-10a7.08,7.08,0,0,1,5.46-1.42,8.68,8.68,0,0,1,4.78,3.32l1.71-.78c0-.19-5.47-17.77-21-15.14-4.73.8-8,4.77-9.2,11.22-2.38,12.47,3.45,30.87,15.88,38.35a26.86,26.86,0,0,0,29.34-.7c9.45-6.47,13.75-18,11.5-30.76-4.85-27.87-28.6-46.66-48.51-50.21C238.56,55.09,226,60.41,219.1,72.33c-9.69,16.74-1.34,36,8.32,58.3,7.46,17.24,15.92,36.79,15.92,57.1,0,38.25-36.67,81.14-89.28,81.58C123.42,269.58,97,256,79.53,231.2c-18.07-25.72-24.15-61.28-14.79-86.47l.92-2.45-2.28,1.27c-.13.07-12.82,7.14-20.71,6.95-12.51-.31-25.39-18.34-25.51-18.52l-1.8-2.54.06,3.13c.6,34.79,27.35,41.17,32.18,42,0,3.36-1.37,17.79-10.28,25.27-6.1,5.14-14.49,5.89-25,2.2ZM87.24,32.26c-.33.11-7.78,3-18.35,12.14l.85,1.66a39.77,39.77,0,0,1,24.32,3c14.18,6.95,18.83,22.89,18.88,23l1.88-.19c.69-13.39-2.22-23.75-8.7-30.77A27.66,27.66,0,0,0,87.24,32.26Zm126.47-3.89,2.63-.49L214,26.59c-.45-.25-10.91-6-20.31-7.19-.56-.07-1.41.14-2.43,1.46-2.86,3.7-6.2,15.92,1.7,35.7l1.85-.64C194.85,50.27,196.34,31.56,213.71,28.37ZM160.22,6.28l-.85-1.92-.9,1.92c-.2.48-19.34,45.31-38.86,85s-28,56.05-26,83c1.88,24.94,14.41,41.94,36.24,50,18.39,6.77,42.26,3.42,55.51-7.81,14.16-12,20.76-24.32,17.73-42.49a50.81,50.81,0,0,0-32.31-39.09c-22.11-8.57-39.21,2.58-47.15,14.75-9.29,14.25-5.34,31.26,2.28,41,10.17,13.1,28.23,13.33,39.49,7.19,8.86-4.82,14.43-18.39,9.6-28.63-5.88-12.5-22-17.28-30.68-7.07-1.33,1.59-6.15,11.25,2,17,4.9,3.47-3.69-8.09,8.64-11.81,4.73-1.42,8.7,2.37,10.25,5.2,3.14,5.67-.26,14.17-7.56,16.68-4.39,1.53-14.46,3.79-22.95-5.87-4.51-5.16-5.7-11-4-18.25,1.69-7.49,6.52-14,12.63-17,7.94-3.88,17.67-3.69,26.72.51s15.73,11.74,17.87,20.23c5.15,20.37-4.68,30.66-12.79,36.86-11.73,9-24.88,10-40.09,5.17a40.32,40.32,0,0,1-27.84-37C105.82,139,129,131,141.38,123.61c11.82-7,14.78-22.84,16.91-29.48,2.15,6.65,3.84,22.44,17,30.68,14.12,8.85,36.43,21,39.8,51,1.13,9.87-.91,50.27-45.62,61.24-22.88,5.58-44.43,1-60.8-13.12-17.22-14.9-26.44-44.3-24.08-67.6,1.43-14,6.83-27.77,11.57-39.9,6.56-16.82,12.23-31.3,5.85-41.6-7.63-12.3-22.68-18.13-39.34-15.24s-38.27,16.3-44.24,44.48c-2.38,11.26,1,21.26,9.4,27.45,9.09,6.75,22.29,7.35,32.84,1.5,12-6.64,16.28-21.12,14.34-32-1.38-7.75-5.71-12.89-11.57-13.8-5.38-.83-9.74,0-12.94,2.53a13.89,13.89,0,0,0-4.94,9l-.24,2.83,1.9-2.12c.19-.19,4.48-4.81,11.09-.7,3.7,2.32,6,7.73,5.56,12.87-.28,3.41-2.12,9.64-11,13.19-7.35,2.92-13.42,2.48-17.11-1.28-4.7-4.78-4.93-14.24-.58-24.64,4.52-10.79,17-21.49,28.45-24.32C70.67,72.87,77,74,81.8,78c12.1,9.92,4.83,31.15-2.2,51.71-4.62,13.52-9.4,27.5-8.68,38.31.9,13.31,5.65,46.51,30.26,67.22,16.58,14,38.83,19.62,66.16,16.81,33.46-3.46,56.22-30.67,61-64.63,3.79-26.8-12.61-59.2-29.24-91S160.47,6.87,160.22,6.28Zm9.93,64.54c0,3.94-.65,7.41-2.3,9.93C166,83.6,163.14,85,159,85a10.43,10.43,0,0,1-9-4.56,16.91,16.91,0,0,1-2-8.76c0-13.5,8.71-33.4,11.52-39.56C162.12,38.08,170.15,57.35,170.15,70.82Zm79.26-23.91.86-1.66c-11.42-9.79-19.37-12.94-20.09-13.11a30.21,30.21,0,0,0-19.81,9.65c-6.94,7.56-10.09,18.65-9.35,33l1.87.22c.06-.18,5.05-17.33,20.34-24.79h0A42.36,42.36,0,0,1,249.41,46.91Z"/>
                        </svg>
                        <div v-html="copydeck.component_payment.ajax_processing_message[lang]"></div>
                        <img class="loading" src="/images/loader.gif" alt=""/>
                    </div>
                </div>
            </form>

        </div>

    </section>

</template>

<script>
import Navigation     from "../components/Navigation.vue";
import NextStepButton from "../components/NextStepButton.vue";
import Subtotal       from "../components/Subtotal.vue";
import Payment        from "../components/Payment.vue";

export default {
    name       : "Coords",
    components : { Payment, Subtotal, NextStepButton, Navigation },


}
</script>

<script setup>

import { onMounted, ref, watch, computed }          from "vue";
import { useMainStore }                   from "../stores/main";
import { storeToRefs }                    from "pinia";
import WaitableButton                     from "../components/WaitableButton.vue";
import { useRouter }                                           from "vue-router";
import { showNewsletter, hideNewsletter, dispatchWindowEvent } from "../composables/utils";


let store  = useMainStore();
let router = useRouter();
let {
        copydeck,
        lang,
        delivery,
        deliveryIsEmail,
        deliveryIsMail,
        oneEmailDeliveryRecipient,
        shipToInvoiceAddress,
        emailToInvoiceEmail,
        giftCardThemes,
        invoice,
        shipping,
        orderCount,
        stripeError,
        orders,
        sortedOrders,
        productByMail,
    }      = storeToRefs( store );


//get composobles function from store
let {
        createPaymentIntent,
        getProductById,

        processOrder,
        processPayment,
        validatePaymentForm,
        hasOrder,

        getFirstThemeId,
        getProductByMail,
        setQuantityByMail,
        getRoute
    }      = store;


let refPayment            = ref( null );
let errors                = ref( [] );
let isProcessingPayment   = ref( false );
let isPreviewModalVisible = ref( false );
let previewModalImageSrc  = ref( '' );
let showModalProcessing   = ref( false );

let sortedOrdersWithoutByMail = computed( () => sortedOrders.value.filter( o => !o.isDeliveryByMail ));


invoice.value.need_different_email_address = !emailToInvoiceEmail.value;

function getDeliveryByProductId ( id_product, index = -1, path = "" , customGiftCard = false)
{

    let oneProduct = delivery.value.deliveredTo.find( o => customGiftCard ? o.index === index : o.id_product === id_product );

    if ( !oneProduct )
    {
        if (customGiftCard)
        {
            oneProduct = { id_product, cards : [], email : "", index };
            delivery.value.deliveredTo.push( oneProduct );
        }
        else if ( id_product != 0 )
        {

            if (id_product < 1)
            {
                index = -1;
            }

            oneProduct = { id_product, cards : [{ to : "", from : "", message: "" }], email : "",  index};
            delivery.value.deliveredTo.push( oneProduct );
        } else
        {
            return null;
        }
    }

    if ( !Array.isArray( oneProduct.cards ) )
    {
        oneProduct.cards = [{ to : "", from : "" , message: ""}];
    }

    if ( index === -1 )
    {
        if (path === "")
            return oneProduct;

        return oneProduct.cards[ 0 ][ path ];
    }

    if (customGiftCard)
    {
        index = 0;
    }

    if ( !oneProduct.cards[ index ] )
    {
        oneProduct.cards[ index ] = { to : "", from : "", message: "" };
    }

    if (path === "")
        return oneProduct;



    return oneProduct.cards[ index ][ path ];
}

function setDeliveryInfo ( id_product, index, path, customGiftCard = false, event )
{

    let oneProduct = getDeliveryByProductId( id_product, index, "", customGiftCard );

    if (index == -1 || customGiftCard)
    {
        index = 0;
    }

    if ( !oneProduct.cards[ index ] )
    {
        oneProduct.cards[ index ] = { to : "", from : "", message: "" };
    }

    oneProduct.cards[ index ].id_product = id_product;
    oneProduct.cards[ index ][ path ]    = event.target.value;
}

async function onStartPaymentProcess ()
{
    let foundErrors = [];

    showModalProcessing.value = true;

    if ( isProcessingPayment.value )
    {
        return;
    }

    let validated = true;

    // validate shipping info
    let form       = refPayment.value.getForm();
    const formData = new FormData( form );

    let invoiceInfoValidation = await validatePaymentForm( formData );

    if ( !invoiceInfoValidation.success )
    {
        validated   = false;
        foundErrors = { ...foundErrors, ...invoiceInfoValidation.errors };
    }

    // payment info
    let paymentInfoValidation = refPayment.value.validateCreditInfo();

    if ( !paymentInfoValidation.success )
    {
        validated   = false;
        foundErrors = { ...foundErrors, ...paymentInfoValidation.errors };
    }


    // both sections are valid, time to pay
    if ( validated )
    {
        let data = await processPayment( oneEmailDeliveryRecipient.value, orders.value );

        if ( data.success )
        {


            dispatchWindowEvent('la-source-cart-changed', { numItems : 0 })

            showConfirmation();

        } else
        {
            validated   = false;
            foundErrors = foundErrors.concat( data.errors );

        }
    }

    errors.value = foundErrors;

    // final step... to show errors
    if ( !validated )
    {
        refPayment.value.showFirstError();
    }

    isProcessingPayment.value = false;
    showModalProcessing.value = false;
}


function showConfirmation ()
{
    router.push( getRoute('confirmation') )
}


function setDeliveryToMode ( bOneEmailDeliveryRecipient )
{
    oneEmailDeliveryRecipient.value = bOneEmailDeliveryRecipient;
    // parent.debouncedResize;
}

function setShipToMode ( bShipToInvoice )
{
    shipToInvoiceAddress.value         = bShipToInvoice;
    delivery.value.needShippingAddress = !bShipToInvoice;
    // parent.debouncedResize;
}

function setEmailToMode ( emailToInvoice )
{
    emailToInvoiceEmail.value                  = emailToInvoice;
    invoice.value.need_different_email_address = !emailToInvoice;
}

function hasError ( strKey )
{
    let strError = errors.value[ strKey ]

    if ( strError === undefined )
        return false;


    return strError !== "";
}

function getErrorMessage ( strKey )
{
    let strError = errors.value[ strKey ]

    if ( copydeck.value.form_errors[ strError ] )
    {
        return copydeck.value.form_errors[ strError ][ lang.value ];
    }

    return "";
}

function checkErrorClass ( strKey )
{
    return hasError( strKey ) ? "status-error" : "";
}


function showModal ( previewUrl )
{
    previewModalImageSrc.value  = previewUrl;
    isPreviewModalVisible.value = true;
}

function getOrderQuantity (order)
{
    if (order.customGiftCard)
    {
        return 1;
    }

    return order.quantity;
}

function getProductName ( order )
{
    let name;

    if (order.customGiftCard)
    {
        name = getProductById( order.id_product, "injectable_name" );
        name = name.replace("__QUANTITY__", order.quantity);
    }
    else
    {
        name = getProductById( order.id_product, "name" );
    }

    return name;
}

watch( () => delivery.value.method, ( newVal, oldVal ) =>
{
    if (newVal === "mail")
    {
        setQuantityByMail(1);
    }
    else if (oldVal === "mail")
    {
        setQuantityByMail(0);
    }
} )

onMounted( () =>
{
    if ( orderCount.value === 0 )
    {
        router.push( { name : "Order" } )
    }

    if (delivery.value.method === "email")
    {
        delivery.value.method = getFirstThemeId();
    }
} )
</script>
